import { makeStyles } from 'tss-react/mui';
import Papyrus from '../../../assets/images/background.jpg';

export const useStyles: any = makeStyles()((/*theme*/) => ({
  backgroundImg: {
    backgroundImage: `url(${Papyrus})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '100vw',
    height: '100vh',
  },

  root: {
    minWidth: 250,
    minHeight: 400,
    width: 350,
    padding: 20,
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 10,
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    '& .MuiTextField-root': {
      marginBottom: '15px',
      width: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.85)',
      borderColor: '#fff',
    },
    '& .MuiButton-root': {
      marginBottom: '15px',
      width: '100%',
      backgroundColor: '#d30535',
      '&:hover': {
        borderColor: '#fff',
        backgroundColor: '#cd5a6e',
        boxShadow: 'none',
      },
    },
    overrides: {
      MuiOutlinedInput: {
        root: {
          position: 'relative',
          '& $notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.23)',
          }, //'&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          '&:hover': {
            borderColor: '#4A90E2',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
              borderColor: 'rgba(0, 0, 0, 0.23)',
            },
          },
          '&$focused $notchedOutline': {
            borderColor: '#4A90E2',
            borderWidth: 1,
          },
        },
      },
      MuiFormLabel: {
        root: {
          '&$focused': {
            color: '#4A90E2',
          },
        },
      },
    },
  },
}));